<div class="row">
    <div class="col-xs-12">
        <div class="card card--box card--box--dashboard">
            <div class="card-block card--box--dashboard__block">
                <div class="mx-auto card--box--dashboard__block__header">
                    <h2>
                        {{ 'Welcome to Klenico Diagnostic system' | translate }}
                    </h2>
                </div>
            </div>
            <div class="card-block card--box--dashboard__block">
                <div class="row d-flex">
                    <div class="col-xs-7">
                        <div class="row">
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn" (click)="handleAddUser()">
                                    <i class="fas fa-plus"></i>
                                    <span class="quickstart__item__name">{{ 'Add new user' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn" [routerLink]="['/clinics']">
                                    <i class="fas fa-hospital"></i>
                                    <span class="quickstart__item__name">{{ 'Clinic Management' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn " [routerLink]="['/templates']">
                                    <i class="fas fa-file-alt"></i>
                                    <span class="quickstart__item__name">{{ 'Email Template' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn " [routerLink]="['/translations']">
                                    <i class="fas fa-comments"></i>
                                    <span class="quickstart__item__name">{{ 'Translations Management' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item" dropdown>
                                <a class="btn quickstart__item__btn" dropdownToggle>
                                    <i class="fas fa-download"></i>
                                    <span class="quickstart__item__name">{{ 'Superadmin Export data' | translate }}</span>
                                </a>
                                <div class="dropdown-menu dropdown-menu-left">
                                    <a class="dropdown-item" (click)="exportClinic($event)">
                                        {{ 'Retrieve Clinics' | translate }}
                                    </a>
                                    <a class="dropdown-item" (click)="exportUser($event)">
                                        {{ 'Retrieve Users' | translate }}
                                    </a>
                                    <a class="dropdown-item" (click)="openExportModal({ action: 'add', title: 'Export Patients', url: '/home', type: 'patients' })">
                                        {{ 'Retrieve Patients' | translate }}
                                    </a>
                                    <a class="dropdown-item" (click)="openExportModal({ action: 'add', title: 'Export Invoice', url: '/home', type: 'invoices' })">
                                        {{ 'Retrieve Invoices' | translate }}
                                    </a>
                                    <a class="dropdown-item" (click)="openExportModal({ action: 'add', title: 'Export Appointments', url: '/home', type: 'appointment-monitoring' })">
                                        {{ 'Retrieve Appointments' | translate }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn " (click)="openFormModal({ action: 'update', id: '1', title: 'Maintenance', url: '' });">
                                    <i class="fas fa-server"></i>
                                    <span class="quickstart__item__name">{{ 'Maintenance' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn" [routerLink]="['/live-questionnaire']">
                                    <i class="fas fa-list"></i>
                                    <span class="quickstart__item__name">{{ 'Live-Questionnaires' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn " [routerLink]="['/activity-dashboard']">
                                    <i class="fas fa-chart-bar"></i>
                                    <span class="quickstart__item__name">{{ 'Activity Dashboard' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item">
                                <a class="btn quickstart__item__btn " [routerLink]="['/support/videos']">
                                    <i class="fas fa-life-ring"></i>
                                    <span class="quickstart__item__name">{{ 'Support Center' | translate }}</span>
                                </a>
                            </div>
                            <div class="col-xs-2 quickstart__item hidden">
                                <a class="btn quickstart__item__btn" [routerLink]="['/self-report-setting/domains']">
                                    <i class="fas fa-folder-tree"></i>
                                    <span class="quickstart__item__name">{{ 'Questionnaires Data Management' | translate }}</span>
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-2 quickstart__item hidden">
                                <a class="btn quickstart__item__btn" [routerLink]="['/service-provider-setting/categories']">
                                    <i class="fas fa-book"></i>
                                    <span class="quickstart__item__name">{{ 'Service Provider Data Management' | translate }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-5 card--box--dashboard__block">
                        <h4 class="title">{{'Notifications' | translate}}</h4>
                        <notification-list></notification-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row mr-t--md">
    <div class="col-xs-12">
        <users-component #usersComponent [isHome]="true"></users-component>
    </div>
</div>

<!-- Modal -->
<div bsModal #modal="bs-modal" class="modal fade"
     tabindex="-1" role="dialog" aria-hidden="true">
    <div *ngIf="params['component'] == null && params['action'] !== 'activate' && params['action'] !== 'delete'"
         class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ params['title'] | translate }}</h4>
            </div>
            <div class="modal-body">
                <button type="button" class="btn btn-link close" (click)="this.modal.hide()" aria-label="Close">
                </button>
                <ng-template [ngIf]="!formLoading">
                    <form [formGroup]="form" novalidate (ngSubmit)="submitSetting(form.value, form.valid)">
                        <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                            <div class="col-md-10">
                                <div class="alert alert-danger">
                                    <div *ngFor="let error of errorMessage">
                                        <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ error |
                                        translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group mat-form">
                            <div class="form-group col-xs-12">
                                <input formControlName="value" value="1" (click)="toggleMaintenance()" type="checkbox" id="enable_maintenance" />
                                <label for="enable_maintenance">{{ 'Enable Maintenance Mode' | translate }}</label>
                            </div>
                            <div class="form-group col-xs-12">
                                <input formControlName="new_feature_notification" (click)="toggleNotification()" type="checkbox" id="show_release_notification" />
                                <label for="show_release_notification">{{ 'Show New Release Notification' | translate }}</label>
                            </div>
                            <div class="form-group col-xs-12">
                                <input formControlName="show_downtime_notification" (click)="toggleDowntimeNotification()" type="checkbox" id="show_downtime_notification" />
                                <label for="show_downtime_notification">{{ 'Show downtime notification' | translate }}</label>
                            </div>
                            <div class="form-group col-xs-4">
                                <div class="form-customized">
                                    <label>{{ 'Release date' | translate }}</label>
                                    <my-date-picker disabled formControlName="release_date" class="kl-datepicker" placeholder="dd.mm.yyyy" [options]="dpkDueDateOptions">
                                    </my-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="row mat-form">
                            <div class="col-xs-9">
                                <label>{{ 'Downtime notification text' | translate }}</label>
                            </div>
                            <div class="col-xs-3">
                                <ul class="list-inline languages">
                                    <ng-container *ngFor="let lang of appService.languages">
                                        <li class="list-inline-item" [class.active]="activeLang['code'] === lang['code']" (click)="activeLang = lang">
                                            <a title="{{ 'Click here to show by ' + lang['name'] | translate }}">
                                                <img src="{{ '/assets/icon/flags/'  + lang['code'].toLowerCase() + '.png' }}" alt="{{lang['name']">
                                            </a>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </div>
                        <div class="row form-group mat-form pos--relative downtime-notification">
                            <div class="col-xs-12 pos--absolute pos--top pos--left" *ngFor="let lang of appService.languages">
                                <app-tinymce [class.active]="activeLang['code'] === lang['code']" row="10" class="mce__downtime"
                                             #tinymce formControlName="release_notification_text_{{ lang['locale']}}">
                                </app-tinymce>
                            </div>
                        </div>

                        <div class="row form-group mat-form">
                            <div class="col-xs-12">
                                <label>{{ 'Maintain text' | translate }}</label>
                                <app-tinymce #tinymce formControlName="text"></app-tinymce>
                            </div>
                        </div>
                        <div *ngIf="params['action'] !== 'read'" class="row">
                            <div class="col-xs-12 text-xs-right">
                                <button type="button" class="btn btn-secondary" (click)="this.modal.hide()">
                                    {{ 'Cancel' | translate }}
                                </button>
                                <button type="submit" class="btn btn-primary">
                                    {{ 'Submit' | translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<!--close <div bsModal ...-->

<!-- Export Modal -->
<div bsModal #exportModal="bs-modal" class="modal fade"
     tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md modal-export-invoices">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{{ params['title'] | translate }}</h4>
            </div>
            <div class="modal-body">
                <button type="button" class="btn btn-link close" (click)="exportModal.hide()" aria-label="Close">
                </button>
                <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                    <div class="col-md-10">
                        <div class="alert alert-danger">
                            <div *ngFor="let error of errorMessage">
                                <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ error | translate }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="form-group col-xs-12">
                        <div class="col-xs-4">
                            <mat-select [placeholder]="'Select Clinic' | translate" [(ngModel)]="invoiceFilters.clinic_id">
                                <mat-option  value=0>{{ 'All clinics' | translate }}</mat-option>
                                <mat-option *ngFor="let clinic of clinics" [value]="clinic['id']">
                                    {{ clinic['name'] }}
                                </mat-option>
                            </mat-select>
                        </div>
                        <div class="col-xs-4">
                            <mat-select [placeholder]="'Select Year' | translate" [(ngModel)]="invoiceFilters.year">
                                <mat-option  value=0 selected>{{ 'All years' | translate }}</mat-option>
                                <mat-option *ngFor="let year of years" [value]="year">
                                    {{ year }}
                                </mat-option>
                            </mat-select>
                        </div>
                        <div class="col-xs-4">
                            <mat-select [placeholder]="'Select Month' | translate" [(ngModel)]="invoiceFilters.month">
                                <mat-option  value=0 selected>{{ 'All months' | translate }}</mat-option>
                                <mat-option *ngFor="let month of months; let i = index" [value]="i + 1">
                                    {{ month | translate}}
                                </mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 text-xs-right">
                        <button type="button" class="btn btn-secondary" (click)="this.exportModal.hide()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button type="submit" class="btn btn-primary" (click)="exportFile($event, params['type'])">
                            {{ 'Export' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--close <div bsModal ...-->

<!-- dowload modal -->
<dialog-component #downloadDialog></dialog-component>
<!-- close download modal -->
